import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { withTranslation } from "react-i18next";

class BuyModal extends Component {

    render() {
        const { t } = this.props;
        if (!this.props.showModal) return null;
        return(
            <Modal
                show={this.props.showModal}
                onHide={this.props.onHide}
                dialogClassName="custom-modal">
                <button onClick={this.props.onHide} title="Close (Esc)" type="button" className="mfp-close">×</button>     
                <Modal.Body className="modal-body-preselctcar">
                    <iframe title="External buy URL" src={this.props.externalURL} scrolling="no" />
                </Modal.Body>
                <div className="mfp-title">{t("product.buynowlabel")}</div>
            </Modal>
        )
    }
}

export default withTranslation()(BuyModal);